module.exports = __webpack_public_path__ + "static/media/logBgButtonPic.52c88d39.jpeg";